import { computed, onMounted, ref } from 'vue'
import { arrowLongSVG_orientationRight, arrowLongSVG_orientationLeft } from '../../foundation/svg/arrow-long'
import { useStore } from 'vuex'
import Glide from '@glidejs/glide'
import ProductSpot from '../ProductSpot/ProductSpot.vue'
import LinkSpot from '../LinkSpot/LinkSpot.vue'
import AboutUsSpot from '../AboutUsSpot/AboutUsSpot.vue'


export default {
    name: 'ProductCarousel',
    components: {
        ProductSpot,
        LinkSpot,
        AboutUsSpot
    },
    props: {
        data: Object,
        carouselType: String,
        carouselTitle: String,
        carouselViewAllLink: String,
        carouselViewAllLinkText: String,
        id: Number
    },
    setup(props) {

        const store = useStore()
        const cardTypeConfig = [{
                name: 'ProductSpot',
                propName: 'productData',
                data: props.data
            },
            {
                name: 'LinkSpot',
                propName: 'scrapedLinkData',
                data: props.data,
            },
            {
                name: 'AboutUsSpot',
                propName: 'scrapedAboutUsData',
                data: props.data
            },
        ]

        const carouselTitle = computed(() => props.carouselTitle)
        const carouselViewAllLink = computed(() => props.carouselViewAllLink)
        const carouselViewAllLinkText = computed(() => props.carouselViewAllLinkText)
        const productSpotData = computed(() => {
            const products = props.data || []
            const showMsrp = store.state.ecom.show_msrp

            return products.map(product => {
                const displayPrice = showMsrp && product.retailPrice ? product.retailPrice : product.price
                const taxLabel = displayPrice && displayPrice.taxLabel ? displayPrice.taxLabel : ""
                return {
                    ...product,
                    price: displayPrice,
                    taxLabel: taxLabel
                }
            })
        })

        const currentCardType = computed(() => {
            const cardType = cardTypeConfig.find(
                (cardType) => cardType.name === props.carouselType
            )

            if (cardType && cardType.name === 'ProductSpot') {
                return {
                    ...cardType,
                    data: productSpotData.value
                }
            }

            return cardType
        })

        const screenWidth = ref(window.innerWidth)

        const maxPerView = 4
        const tabletPerView = 3
        const tabletScreenWidth = 920
        const mobilePerView = 2
        const mobileScreenWidth = 768

        const showScrollbar = computed(() => {
            const moreThanMaxPerView = (currentCardType.value.data ? (currentCardType.value.data.length > maxPerView) : false)
            const tabletCheck = (screenWidth.value < tabletScreenWidth) && (screenWidth.value >= mobileScreenWidth) && (currentCardType.value.data.length > tabletPerView)
            const phoneCheck = (screenWidth.value < mobileScreenWidth) && (currentCardType.value.data.length > mobilePerView)

            return moreThanMaxPerView || tabletCheck || phoneCheck
        })

        const hasMoreCarouselItemsThanFour = computed(() => currentCardType.value.data.length > 4)

        onMounted(() => {
            const glide = document.querySelectorAll(`.glide-${props.id}`)

            window.onresize = () => {
                screenWidth.value = window.innerWidth
            }
            let lessThanOrEqDesktopMax =  currentCardType.value.data.length <= maxPerView
            let lessThanOrEqTabletMax =  currentCardType.value.data.length <= tabletPerView
            let lessThanOrEqMobileMax =  currentCardType.value.data.length <= mobilePerView
            let sliderObj = {};

            glide.forEach((glideItem, index) => {

                if (glideItem) {
                    sliderObj[index] = new Glide(`.glide-${props.id}`, {
                        type: lessThanOrEqDesktopMax ? 'slider' : 'carousel',
                        gap: 40,
                        keyboard: false,
                        startAt: 0,
                        perView: maxPerView,
                        swipeThreshold: lessThanOrEqDesktopMax ? false : 80,
                        dragThreshold: lessThanOrEqDesktopMax ? false : 120,
                        keyboard: !lessThanOrEqDesktopMax, 
                        breakpoints: {
                            [tabletScreenWidth]: {
                                perView: tabletPerView,
                                type: lessThanOrEqTabletMax ? 'slider' : 'carousel',
                                swipeThreshold: lessThanOrEqTabletMax ? false : 80,
                                dragThreshold: lessThanOrEqTabletMax ? false : 120,
                            },
                            [mobileScreenWidth]: {
                                perView: mobilePerView,
                                gap: 10,
                                type: lessThanOrEqMobileMax ? 'slider' : 'carousel',
                                swipeThreshold: lessThanOrEqMobileMax ? false : 80,
                                dragThreshold: lessThanOrEqMobileMax ? false : 120,
                            },
                        },
                    })

                    // Workaround for ensuring keyboard navigation works when multiple carousels are on the same page. Reason due to glidejs bug
                    glideItem.addEventListener('keyup', (e) => {
                        if (e.keyCode == 39) sliderObj[index].go('>')
                        if (e.keyCode == 37) sliderObj[index].go('<')
                    })
                    sliderObj[index].mount()
                }
            })
        })

        return {
            indexFromProps: props.id,
            carouselTitle,
            carouselViewAllLink,
            carouselViewAllLinkText,
            hasMoreCarouselItemsThanFour,
            arrowLongSVG_orientationRight,
            arrowLongSVG_orientationLeft,
            currentCardType,
            showScrollbar
        }
    },
}
